/**
 * @desc 财务收支应用表分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.FinanceAccountResponseDto>
>;
export function request(
  params: API.basics.financeAccount.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/financeAccount/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
